<script setup>
import { usePlaylistStore } from "@/stores/playlist.js";
import { enableScroll, disableScroll } from "@/Helpers/scroll";
import { ref, onBeforeMount, onMounted, computed, watch, getCurrentInstance } from 'vue';
import { scrollToSlide } from '@/Helpers/scroll.js'

const props = defineProps({
    row: {
        type: Object,
        default: undefined,
    },
    cardIndex: {
        type: Number,
        default: undefined,
    },
    playlistId: {
        type: Number,
        default: undefined,
    },
    isIntersecting: Boolean,
    scormExport: Boolean,
})
const store = usePlaylistStore();
const instance = getCurrentInstance();
const arrAnswers = ref([]);
const sliderValue = ref(0);
const rangeSlider = ref(null);
const isAnswered = ref(false);

const scormApi = ref(null);
if (props.scormExport) {
    scormApi.value = instance.appContext.config.globalProperties.$scorm.api;
}

onBeforeMount(() => {
    generateAnswers()
    sliderValue.value = props.row.content.rangeDefault || props.row.content.rangeMin;
});

onMounted(() => {
    setPreviousAnswer()
});

watch(
    () => props.isIntersecting,
    (newVal, oldVal) => {
        if (props.isIntersecting === true && isAnswered.value === false) {
            disableScroll();
        } else if (props.isIntersecting === true && isAnswered.value === true) {
            enableScroll();
        }
        if (newVal === false && oldVal === true) {
            enableScroll();
        }
    }
);

const slideAnswer = computed(() => {
    const match = props.row.content.answers.find(answer => parseInt(sliderValue.value) >= answer.start && parseInt(sliderValue.value) <= answer.end);
    return match ? match.message : '';
})

function generateAnswers() {
    let answers = props.row.content.answers

    for (let i = 0; i < answers.length; i++) {
        for (let j = parseInt(answers[i].start); j <= parseInt(answers[i].end); j++) {
            arrAnswers.value[j] = answers[i].message
        }
    }
}

function setPreviousAnswer() {
    const answer = store.getPreviousAnswer(props.row.id);
    if (answer) {
        sliderValue.value = parseInt(answer);
        rangeSlider.value.setAttribute('disabled','disabled');
        isAnswered.value = true;
    }
}

function storeAnswer() {

    if (!isAnswered.value) {
        const data = {
            playlist_id: props.playlistId,
            playlist_card_row_id: props.row.id,
            type: props.row.type,//'Confidence', 'ConfidenceConfirmation'
            question: props.row.content.question,
            answer: ''+sliderValue.value,
            isCorrect: true,
        }

        if (props.scormExport && scormApi.value) {
            scormApi.value.recordInteraction(data);
            isAnswered.value = true;
        } else {
            const url = '/activity/store_response'
            axios.post(url, data)
                .then(function (response) {
                    isAnswered.value = true;
                })
                .catch(function (error) {
                    console.error(error)
                });
        }
    }
    enableScroll();
    scrollToSlide(props.cardIndex + 1);
}
</script>
<template>
    <div class="relative p-fl-4 w-full h-full">
        <div class="relative z-10 w-full h-full flex flex-col px-fl-4">
            <h3 v-if="row.content.prefix" class="pt-fl-2 text-fl-lg" v-text="row.content.prefix" />
            <div class="text-fl-4xl pt-fl-4 font-black" :style="'font-family: var(--heading-font, var(--font));'">
                {{ row.content.question }}
            </div>
            <div class="pb-fl-6 grow flex flex-col justify-end w-full">
                <div class="pt-fl-3 text-fl-xl">
                    {{ slideAnswer }}
                </div>
                <div class="text-fl-5xl font-black pt-fl-3 pb-fl-5">
                    {{ sliderValue }}{{ row.content.rangeSuffix }}
                </div>
                <input
                    ref="rangeSlider"
                    v-model="sliderValue"
                    type="range"
                    :min="row.content.rangeMin"
                    :max="row.content.rangeMax"
                    class="slider allow-touch"
                    :disabled="isAnswered"
                >
            </div>
            <div class="flex flex-col w-full">
                <button
                    type="button"
                    class="place-self-end rounded-full 
                    px-fl-4 
                    py-fl-2 
                    font-bold 
                    shadow-sm 
                    border-2
                    focus-visible:outline 
                    focus-visible:outline-2 
                    focus-visible:outline-offset-2 
                    focus-visible:outline-white"
                    @click="storeAnswer"
                >
                    {{ isAnswered ? 'Continue' : 'Submit' }}
                </button>
            </div>
        </div>
    </div>
</template>

<style scoped>
.slider {
    -webkit-appearance: none;
    appearance: none;
    width: 100%;
    height: 20px;
    background: var(--button_bg);
    outline: none;
    opacity: 0.7;
    -webkit-transition: .2s;
    transition: opacity .2s;
    border-radius: 10px;
}

.slider:hover {
    opacity: 1;
}

.slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 35px;
    height: 35px;
    background: var(--button_hover_bg);
    border: 3px solid var(--button_bg);
    cursor: pointer;
    border-radius: 50%;
}

.slider::-moz-range-thumb {
    width: 35px;
    height: 35px;
    background: var(--button_hover_bg);
    border: 3px solid var(--button_bg);
    cursor: pointer;
    border-radius: 50%;
}

button {
    border-color: var(--button_bg);
    background-color: var(--button_bg);
    color: var(--button_text);
}

button:hover {
    background-color: var(--button_hover_bg);
    color: var(--button_hover_text);
}
</style>